import React from "react";
import { SubMenu } from "../index";
import { Link } from "react-router-dom";
import styles from "../../styles.module.sass";
import { BrandListingsIcon } from "../../icons";
import Strings from "../../../../i18n/strings/navigation";
import { useTranslation } from "../../../../shopx-shared-components/hooks/useTranslation";
import { useUserAccess } from "../../../AuthenticatedRoutes";
interface IProps {
  activeNavigate: (values: string) => boolean;
  collapsed: boolean;
}
const CollapseBrandListings: React.FC<IProps> = ({
  activeNavigate,
  collapsed,
}) => {
  const { t } = useTranslation("navigation");
  const { hasStampsEnabled } = useUserAccess();
  return (
    // @ts-ignore - SubMenu is valid but TS has wrong types
    <SubMenu
      active={activeNavigate("/brand")}
      key={"brand"}
      title={t(Strings.brandListing)}
      icon={<BrandListingsIcon clicked={activeNavigate("brand")} />}
      clicked={activeNavigate("brand")}
      collapsed={collapsed}
    >
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/info"}
        className={
          activeNavigate("info")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.brandInfo)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/visuals"}
        className={
          activeNavigate("visuals")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.brandVisuals)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/menu"}
        className={
          activeNavigate("/brand/menu")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.menuItems)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/gift-list"}
        className={
          activeNavigate("gift-list")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.giftList)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/referral-gifts"}
        className={
          activeNavigate("referral-gifts")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.referralGifts)}
      </Link>
      {hasStampsEnabled && (
        <>
          {/* @ts-ignore - Link is valid but TS has wrong types */}
          <Link
            to={"/brand/stamps"}
            className={
              activeNavigate("stamps")
                ? styles.activeCollapseItem
                : styles.collapseItem
            }
          >
            {t(Strings.stamps)}
          </Link>
        </>
      )}
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/converting_ratio"}
        className={
          activeNavigate("converting_ratio")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.convertingRatio)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/social"}
        className={
          activeNavigate("social")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.socialLinks)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/gifting_points"}
        className={
          activeNavigate("gifting_points")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.giftingPoints)}
      </Link>
      {/* @ts-ignore - Link is valid but TS has wrong types */}
      <Link
        to={"/brand/subscription_plans"}
        className={
          activeNavigate("subscription_plans")
            ? styles.activeCollapseItem
            : styles.collapseItem
        }
      >
        {t(Strings.subscriptionPlans)}
      </Link>
    </SubMenu>
  );
};

export default CollapseBrandListings;